export const CMS = "cms";
export const HOME = "home";
export const BLOG = "blog";
export const CAREERS = "careers";
export const GALLERY = "gallery";
export const RESORT = "resort";
export const ENQUIRY = "enquiry";
export const ROOM = "room";
export const ROOMBOOKING = "roombooking";